import { shopActionTypes } from './Constants';

export function getShopRequest(shopId, isPublicShop, paymentType) {
	return {
		type: shopActionTypes.GET_SHOP_DATA,
		payload: {
			shopId,
			isPublicShop,
			paymentType,
		},
	};
}

export function getShopSuccess(shopData, discountCode) {
	return {
		type: shopActionTypes.GET_SHOP_DATA_SUCCESS,
		payload: {
			shopData,
			discountCode,
		},
	};
}

export function getPaymentRequestsShopRequest(shopId, packageId, paymentType) {
	return {
		type: shopActionTypes.GET_PAYMENT_REQUESTS_SHOP_DATA,
		payload: {
			shopId,
			packageId,
			paymentType,
		},
	};
}

export function getPaymentRequestsShopSuccess(shopData, discountCode) {
	return {
		type: shopActionTypes.GET_PAYMENT_REQUESTS_SHOP_DATA_SUCCESS,
		payload: {
			shopData,
			discountCode,
		},
	};
}

export function getPaymentMethodsRequest() {
	return {
		type: shopActionTypes.GET_PAYMENT_METHODS_REQUEST,
	};
}

export function getPaymentMethodsSuccess(paymentMethods) {
	return {
		type: shopActionTypes.GET_PAYMENT_METHODS_SUCCESS,
		payload: {
			paymentMethods,
		},
	};
}

export function handleSubscriptionRequest(paymentIntentId, pageType, shopData) {
	return {
		type: shopActionTypes.HANDLE_SUBSCRIPTION_REQUEST,
		payload: {
			paymentIntentId,
			pageType,
			shopData,
		},
	};
}

export function handleSubscriptionSuccess() {
	return {
		type: shopActionTypes.HANDLE_SUBSCRIPTION_SUCCESS,
	};
}

export function cleanShopData() {
	return {
		type: shopActionTypes.CLEAN_SHOP_DATA,
	};
}

export function getFailedPaymentsRequest(invoiceId, secret, paymentType) {
	return {
		type: shopActionTypes.GET_FAILED_PAYMENTS_REQUEST,
		payload: {
			invoiceId,
			secret,
			paymentType,
		},
	};
}

export function getFailedPaymentsSuccess(shopData) {
	return {
		type: shopActionTypes.GET_FAILED_PAYMENTS_SUCCESS,
		payload: {
			shopData,
		},
	};
}
